import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  CloudUploadOutlined,
  ThunderboltOutlined,
  DashboardOutlined,
  RiseOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByIndex: Record<number, JSX.Element> = {
  0: <CloudUploadOutlined />,
  1: <ThunderboltOutlined />,
  2: <DashboardOutlined />,
  3: <SafetyCertificateOutlined />,
};

const BenefitsSection = () => {
  const { t } = useTranslation("hrm");

  const items = useMemo(() => {
    const raw = t("benefits.items", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ title: string; desc: string }>;
  }, [t]);

  return (
    <section className="dev-hrm-section dev-hrm-benefits-section">
      <div className="dev-hrm-section-inner">
        <h2 className="dev-section-h2 dev-hrm-section-h2">
          <span className="dev-hrm-section-h2-icon dev-hrm-section-h2-icon--amber" aria-hidden>
            <RiseOutlined />
          </span>
          <span>{t("benefits.title")}</span>
        </h2>

        <div className="dev-hrm-benefits-grid">
          {items.slice(0, 5).map((item, idx) => (
            <div key={idx} className="dev-hrm-benefit-card">
              <div className="dev-hrm-benefit-left">
                <span className="dev-hrm-benefit-number">{String(idx + 1).padStart(2, "0")}</span>
                <span className="dev-hrm-benefit-icon">{iconByIndex[idx] ?? null}</span>
              </div>
              <div className="dev-hrm-benefit-body">
                <div className="dev-hrm-benefit-title">{item.title}</div>
                <div className="dev-hrm-benefit-desc">{item.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;

